import { WidgetConfig } from "@aichat/types/widget";

export const BRAND_COLOR_DEFAULT = {
  h: 120,
  s: 60,
  l: 50,
  a: 1,
};

export const defaultWidgetConfig: WidgetConfig = {
  focus: "",
  textColor: "light",
  chatbotDisplayName: "JiriAI",
  avatarType: "light",
  greetingHeaderSubtitle: "Ask any question for our AI to answer",
  greetingHeaderTitle: "Chat with our AI ✨",
  placeholderMessage: "Type your message here...",
  brandColor: BRAND_COLOR_DEFAULT,
  brandColorAsBgLauncher: true,
  starterIcon: true,
  starterSuggestions: [],
  isThemeSleek: false,
  additionalChannels: [],
  liveAgentAvatarType: "light",
};
